import './css/MemberDetail.css'

import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Form, Col, Row, Button, Radio } from 'antd'
import { baseAxiosNoInfo } from '../../tool/axios'
import _ from 'lodash'

// Tab栏目组件引入
// 商城订单
import OlineretailOrder from './MemberMallOrderList'

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 6 }
}

type UserType = {
    "member_id": string,
    "user_name": string,
    "phone": string,
    "birthday": null | string,
    "head_pic_url": string,
    "mall_consume_amount": number,
    'other_consume_amount': number,
    'total_consume_amount': number,
    'left_points': number,
    'total_consume_points': number,
    "register_channel": string,
    "create_date": string
}

export default function OrderDetail() {

    const { id }: { id: string } = useParams()
    const [userData, setUserData] = useState<undefined | UserType>()
    const [btnSize, setBtnSize] = useState<Number>(1)

    useEffect(() => {
        if (id) {
            baseAxiosNoInfo('/member_center/member/detail', { params: { member_id: id } }).then((res: any) => {
                if (res) {
                    setUserData(res)
                }
            })
        }
    }, [id])

    // 加载Tab栏目组件数据
    function renderModuleComp() {
        switch (btnSize) {
            case 1: return <OlineretailOrder /> // 商城订单
            default: return <OlineretailOrder /> // 商城订单
        }
    }

    return (<div className="order-list-add common-level2-edit">
        {/* 会员中心 -> 会员管理 -> 会员列表 -> 会员详情 */}
        <div className="sections">
            <h2>会员详情</h2>

            <div className="clear" style={{ paddingLeft: 16, marginBottom: 16 }} >
                <Button size="small" onClick={() => { window.history.go(-1) }} >返回</Button>
            </div>

            <div className="sections-content">
                <Form {...formItemLayout} >
                    {/* ******************** 会员基本信息 ******************** */}
                    <Row>
                        <Col span={12}>
                            <Form.Item label="会员头像">
                                <img style={{ width: 100, height: 100, borderRadius: '100%' }} src={userData?.head_pic_url} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row>
                        <Col span={12}>
                            <Form.Item label="会员昵称">
                                {userData?.user_name}
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item label="注册渠道" >
                                {userData?.register_channel}
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row>
                        <Col span={12}>
                            <Form.Item label="手机号码">
                                {userData?.phone}
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item label="注册时间">
                                {userData?.create_date}
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row>
                        <Col span={12}>
                            <Form.Item label="会员生日">
                                {userData?.birthday}
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* ******************** 会员积分信息 ******************** */}
                    <Row>
                        <Col span={12}>
                            <Form.Item label="已消费总金额">
                                {userData?.total_consume_amount}
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item label="已消费积分">
                                {userData?.total_consume_points}
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* ******************** 会员消费信息 ******************** */}
                    <Row>
                        <Col span={12}>
                            <Form.Item label="电商消费金额">
                                {userData?.mall_consume_amount}
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item label="剩余积分">
                                {userData?.left_points}
                            </Form.Item>

                        </Col>
                    </Row>

                    <Row>
                        <Col span={12}>
                            <Form.Item label="其他消费金额">
                                {userData?.other_consume_amount}
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>

                {/* 信息筛选按钮 */}
                <div className="sections-btn-group">
                    <Radio.Group size="large" value={btnSize} onChange={e => { setBtnSize(e.target.value) }}>
                        <Radio.Button value={1}>商城订单</Radio.Button>
                    </Radio.Group>

                    {/* 根据选择的Tab组件，展示对应的数据 */}
                    <div className='detail-tab-box'>
                        {
                            renderModuleComp()
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>)
}